import API from '../api'

export type Property = {
  displayName: string,
  propertyId: number
}

export type Customer = {
  displayName: string,
  customerId: number,
  properties: Property[]
}

export type SearchResponse = {
  customers: Customer[],
  total: number
}

export const SearchCustomerPropertiesUrl = '/web/customers/search/properties'

export const getCustomerPage = async (page: number, pageSize: number, filter: string) => {
  const request = {
    url: SearchCustomerPropertiesUrl,
    params: {
      page,
      pageSize,
      filter
    }
  }
  return await (await API.request<SearchResponse>(request)).data
}